import React from "react";
import { cloneDeep } from "lodash";
import { regionOptions, countryOptions, usaStates } from "./countryOptions";

export const unwantedAreaOptions = [
    "na", "any",
];
const fieldsWithUnwantedOptions = [
    "giaFilter",
    "externalAreaFilter",
    "lotSizeCommFilter",
    "ageCarsFilter",
    "sizeYachtFilter",
    "ageYachtsFilter",
    "ageJetsFilter",
    "ageWineFilter",
];

export const fieldsWithNoAllInSellListingCreation = [
    "ageCarsFilter",
    "sizeYachtFilter",
    "ageYachtsFilter",
    "ageJetsFilter",
    "ageWineFilter",
];

export const arrayHasAll = (main, target) => {
    return target.every(element => main.includes(element));
};

export const getCountryCountInGivenRegions = regions => {
    const filteredCountries = countryOptions.filter(c => regions.includes(c.region));
    return filteredCountries.length;
};

export const trimText = (text, max) => {
    const clonedText = cloneDeep(text);
    const cutText = clonedText.length > max
        ? clonedText.slice(0, (max - 3)) + '...'
        : clonedText;
    return cutText;
};

export const getSubcategories = query => {
    if (query) {
        const [prefix, items] = query.split(":");
        const subcategories = items.split(",");
        return subcategories;
    } else {
        return [];
    };
};

export const customModifySearchFilters = (filters) => {
    const filtersToTake = filters || {};
    const {
        pub_region,
        pub_country,
    } = filtersToTake;

    const newFilters = filtersToTake;
    const regions = getSubcategories(pub_region);
    const countries = getSubcategories(pub_country);

    if (regions.length > 0 && countries.length > 0) {
        const fullCountryInfo = countryOptions.filter(c => countries.includes(c.value));
        const neededCountries = fullCountryInfo.filter(c => regions.includes(c.region));
        const countryValues = neededCountries.map(c => c.value).join(",");

        newFilters.pub_country = `has_any:${countryValues}`;
    };
    if (!countries.includes("unitedStates")) {
        delete newFilters.pub_state;
    };

    fieldsWithUnwantedOptions.map(f => {
        const fieldOptions = getSubcategories(filtersToTake[`pub_${f}`]);

        if (fieldOptions.length > 0) {
            let newOptions = [];
            if (fieldOptions.some(o => unwantedAreaOptions.includes(o))) {
                const validOptions = fieldOptions.filter(o => !unwantedAreaOptions.includes(o));
                if (validOptions.length > 0) {
                    newOptions = [
                        ...validOptions,
                        ...unwantedAreaOptions,
                    ];
                };
            } else {
                newOptions = [
                    ...fieldOptions,
                    ...unwantedAreaOptions,
                ];
            };

            if (newOptions.length > 0) {
                newFilters[`pub_${f}`] = `has_any:${newOptions}`;
            } else {
                delete newFilters[`pub_${f}`];
            };
        };
    });

    return newFilters;
};

export const cleanFiltersFromUnwantedOptions = (filters = []) => {
    const newFilters = [];
    filters.map(filter => {
        const { key, enumOptions } = filter;
        if (fieldsWithUnwantedOptions.includes(key)) {
            const newOptions = enumOptions.filter(o => !unwantedAreaOptions.includes(o.option));
            newFilters.push({
                ...filter,
                enumOptions: newOptions,
            });
        } else {
            newFilters.push(filter);
        };
    });
    return newFilters;
};

export const mainWarningParams = {
    title: "Platform Terms Reminder:",
    content: <ul>
        <li>Members must be principals or direct representatives</li>
        <li>Misleading communications result in immediate removal</li>
        <li>No introductions without relevant asset ownership</li>
    </ul>
};

export const getListingLocationText = (publicData, isListingCard) => {
    // remember to change this function in backend too
    const {
        listingType,
        Location_preference,
        approximate_asset_location,
        region,
        country,
        city,
    } = publicData || {};

    const isSearch = listingType === 'search';

    let initialText = city ? `${city}, ` : "";

    const showRegionNotCountry = isListingCard && isSearch;

    if (!showRegionNotCountry && country && Array.isArray(country) && country.length > 0) {
        const countryOption = countryOptions.filter(o => country.includes(o.value));
        const countryText = countryOption.map(c => c.label).join(", ");
        initialText += countryText;
    } else if (region && Array.isArray(region)) {
        const allRegionOptions = [
            ...regionOptions,
            { value: "global", label: "Global" },
            { value: "notApplicable", label: "Not Applicable" },
        ];

        const regionOption = allRegionOptions.filter(o => region.includes(o.value));
        const regionText = regionOption.map(c => c.label).join(", ");
        initialText += regionText;
    } else {
        initialText += isSearch
            ? Location_preference
            : approximate_asset_location;
    };

    return initialText;
};

export const getImprovedLocationText = (publicData) => {
    // remember to change this function in backend too
    const {
        listingType,
        Location_preference,
        approximate_asset_location,
        region,
        country,
        state,
    } = publicData || {};

    const isSearch = listingType === 'search';

    const regionOptionsKeys = regionOptions.map(o => o.value);
    const allRegionOptions = [
        ...regionOptions,
        { value: "global", label: "Global" },
        { value: "notApplicable", label: "Not Applicable" },
    ];

    const regionExists = region && Array.isArray(region) && region.length > 0;
    const countryExists = country && Array.isArray(country) && country.length > 0;
    const stateExists = state && Array.isArray(state) && state.length > 0;
    const onlySelectedUsa = countryExists && country.length == 1 && country.includes("unitedStates");

    const numOfCountriesInSelected = countryExists ? country.length : 0;
    const numOfCountriesInSelectedRegions = regionExists ? getCountryCountInGivenRegions(region) : 0;
    const selectedAllCountriesInGivenRegions = countryExists
        && regionExists
        && numOfCountriesInSelected == numOfCountriesInSelectedRegions;

    if (regionExists && region.includes("notApplicable")) {
        return "Not Applicable";
    } else if (regionExists && (region.includes("global") || arrayHasAll(region, regionOptionsKeys))) {
        return "Global";
    } else if (regionExists && (!countryExists || selectedAllCountriesInGivenRegions)) {
        const regionOption = allRegionOptions.filter(o => region.includes(o.value));
        const regionText = regionOption.map(c => c.label).join(", ");
        return regionText;
    } else if (countryExists && !onlySelectedUsa) {
        const countryOption = countryOptions.filter(o => country.includes(o.value));
        const countryText = countryOption.map(c => c.label).join(", ");
        return countryText;
    } else if (onlySelectedUsa) {
        if (stateExists && state.length !== usaStates.length) {
            const stateOption = usaStates.filter(o => state.includes(o.value));
            const stateText = stateOption.map(c => c.label).join(", ");
            return stateText;
        } else {
            return "United States";
        };
    } else {
        return isSearch ? Location_preference : approximate_asset_location;
    };
};

export const formatNumberToHumanOutput = (num) => {
    if (num >= 1_000_000_000_000) {
        const val = num / 1_000_000_000;
        return `£${Math.floor(val)}bn`;
    };

    if (num >= 1_000_000_000) {
        // billions — max 1 decimal
        const val = num / 1_000_000_000;
        return val % 1 === 0 ? `£${val}bn` : `£${val.toFixed(1)}bn`;
    };

    if (num >= 1_000_000) {
        // millions — no decimals
        const val = Math.floor(num / 1_000_000);
        return `£${val}m`;
    };

    if (num >= 1_000) {
        // thousands — no decimals
        const val = Math.floor(num / 1_000);
        return `£${val}k`;
    };

    // below 1000 — integer only (no decimals)
    return `£${String(Math.floor(num))}`;
};

export const getWordsCount = text => {
    const trimmedText = text.trim();

    if (trimmedText === "") {
        return 0;
    };

    // Split the string by one or more whitespace characters
    const words = trimmedText.split(/\s+/);

    return words.length;
};

export const getFirstNWords = (text, num) => {
    // Split on any whitespace, the same way getWordsCount does, so line breaks
    // don't hide several words inside one "word" and blow past the limit.
    const words = text.trim().split(/\s+/);
    const firstNWords = words.slice(0, num);
    return firstNWords.join(' ') + "... ";
};

// Whether the paywall is switched on at all. When it is off,
// userHasValidSubscription below treats everyone as subscribed, so this is the
// only way to tell "this member pays" from "nobody is being charged yet". The
// paywall tracker needs that difference: with the paywall off there is no
// paywall to record.
export const isPaywallActive = () => !!process.env.REACT_APP_PAYWALL_ACTIVE;

export const userHasValidSubscription = user => {
    if (!process.env.REACT_APP_PAYWALL_ACTIVE) {
        return true;
    };

    const userSubscriptionMaybe = user?.attributes?.profile?.metadata?.subscriptionStatus;
    const validSubscriptionsTitles = ["active", "legacy", "offplatform-subscription"];
    const userHasValidSubscription = validSubscriptionsTitles.includes(userSubscriptionMaybe);

    return userHasValidSubscription;
};
